const updateSavingsInfo = {
    "gameID":  "65d22010fd5d67dd2c04f374",           
  "__v": 0,
  "currentlyActive": true,
  "dateAdded": "2025/09/13",
  "dateUpdated": "2025/09/13",
  "savingsArr": [
    {
      "savingsType": "CD",
      "interestRate": "3.40",
      "intRateStartDate": "2025-09",
      "monthlyDepositAmt": 0,
      "yearArr": [
        {
          "year": "2025",
          "totalInterest": "11.3494",
          "penaltyAmt": 0
        }
      ],
      "totalDeposited": "2000",
      "totalTransferAmt": "0",
      "nbrTransfers": "0",
      "totalTransferFee": "0",
      "totalInterestAmt": "11.3494",
      "startDate": "2025-09",
      "closedDate": "",
      "autoRollover": true
    },
    {
      "savingsType": "highYield",
      "interestRate": "2.80",
      "intRateStartDate": "2025-09",
      "monthlyDepositAmt": "400",
      "yearArr": [
        {
          "year": "2025",
          "totalInterest": "7.4743",
          "penaltyAmt": 0
        }
      ],
      "totalDeposited": "1800.00",
      "totalTransferAmt": "0",
      "nbrTransfers": "0",
      "totalTransferFee": "0",
      "totalInterestAmt": "7.4743",
      "startDate": "2025-09",
      "closedDate": ""
    },
    {
      "savingsType": "401K",
      "interestRate": "11.00",
      "intRateStartDate": "2025-09",
      "monthlyDepositAmt": "1000",
      "yearArr": [],
      "totalDeposited": "4000.00",
      "totalTransferAmt": "0",
      "nbrTransfers": "0",
      "totalTransferFee": "0",
      "totalInterestAmt": "64.4188",
      "startDate": "2025-09",
      "closedDate": ""
    }
  ],
  "totalSavingsAmt": "7883.24"
}

export default updateSavingsInfo;